import { $ } from "@utils/dom";
import { DATA_ATTR } from "@constants/data-attributes";
import { CSS } from "@constants/css-classes";

/**
 * Initialize accessible mobile sidebar toggle functionality
 */
export function initMobileSidebar(): void {
  const sidebar = $(DATA_ATTR.MOBILE_SIDEBAR);

  if (!sidebar) return;

  const trigger = $<HTMLButtonElement>(DATA_ATTR.MOBILE_SIDEBAR_TRIGGER, sidebar);
  const panel = $(DATA_ATTR.MOBILE_SIDEBAR_PANEL, sidebar);
  const iconOpen = $(DATA_ATTR.MOBILE_SIDEBAR_ICON_OPEN, sidebar);
  const iconClose = $(DATA_ATTR.MOBILE_SIDEBAR_ICON_CLOSE, sidebar);
  const backdrop = $(DATA_ATTR.MOBILE_BACKDROP);

  if (!trigger || !panel) return;

  const openPanel = (): void => {
    trigger.setAttribute("aria-expanded", "true");
    iconOpen?.classList.add(CSS.HIDDEN);
    iconClose?.classList.remove(CSS.HIDDEN);
    panel.classList.remove(CSS.OPACITY_0, CSS.INVISIBLE, CSS.SCALE_0);
    panel.classList.add(CSS.OPACITY_100, CSS.VISIBLE, CSS.SCALE_100);
    backdrop?.classList.remove(CSS.OPACITY_0, CSS.INVISIBLE);
    backdrop?.classList.add(CSS.OPACITY_100, CSS.VISIBLE);
    document.dispatchEvent(new CustomEvent("mobile-sidebar:open"));
  };

  const closePanel = (): void => {
    if (trigger.getAttribute("aria-expanded") !== "true") return;

    trigger.setAttribute("aria-expanded", "false");
    iconOpen?.classList.remove(CSS.HIDDEN);
    iconClose?.classList.add(CSS.HIDDEN);
    panel.classList.add(CSS.OPACITY_0, CSS.INVISIBLE, CSS.SCALE_0);
    panel.classList.remove(CSS.OPACITY_100, CSS.VISIBLE, CSS.SCALE_100);
    backdrop?.classList.add(CSS.OPACITY_0, CSS.INVISIBLE);
    backdrop?.classList.remove(CSS.OPACITY_100, CSS.VISIBLE);
  };

  const togglePanel = (): void => {
    const isExpanded = trigger.getAttribute("aria-expanded") === "true";
    isExpanded ? closePanel() : openPanel();
  };

  trigger.addEventListener("click", (e) => {
    e.stopPropagation();
    togglePanel();
  });

  trigger.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      togglePanel();
    }
    if (e.key === "Escape") {
      closePanel();
      trigger.focus();
    }
  });

  panel.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closePanel();
      trigger.focus();
    }
  });

  document.addEventListener("click", (e) => {
    if (!sidebar.contains(e.target as Node)) {
      closePanel();
    }
  });

  document.addEventListener("mobile-nav:open", closePanel);
}
